import React, { useEffect, useState } from "react";
import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { useDispatch, useSelector } from "react-redux";
import { addQuiz, fetchAllCategoriesAction } from "actions/quiz";

const AutocompleteCategory = ({ q }) => {
  const dispatch = useDispatch();

  const { quiz, quizCategories } = useSelector((state) => state.quizs);

  useEffect(() => {
    dispatch(fetchAllCategoriesAction());
  }, [dispatch]);

  const handleOnchange = (data) => {
    dispatch(addQuiz(data));
  };
  const handleSelection = (selected) => {
    if (selected.length > 0) {
      handleOnchange({
        ...quiz,
        questions: quiz.questions.map((element) => {
          if (element._id === q._id) {
            return { ...element, category: selected[0].name };
          }
          return element;
        }),
      });
    }
  };

  const options = [...quizCategories];
  return (
    <div className="mb-3">
      <Typeahead
        id="autocomplete-example"
        labelKey="name"
        options={options}
        placeholder="Type to search Category..."
        selected={[q?.category]}
        onChange={handleSelection}
        onInputChange={(e) =>
          handleOnchange({
            ...quiz,
            questions: quiz.questions?.map((element) => {
              if (element._id === q._id) {
                return { ...element, category: e };
              }
              return element;
            }),
          })
        }
      />
    </div>
  );
};

export default AutocompleteCategory;
